// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabCurrent_tab-current__dsDKC {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 8px 0 32px;
}
.TabCurrent_tab-current__intro__FS9gQ {
  max-width: 800px;
  margin-bottom: -16px;
}
.TabCurrent_tab-current__intro__FS9gQ p {
  color: var(--text-2, #6b7280);
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.TabCurrent_kpi-row__e6y9a {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
  margin-bottom: 8px;
}

.TabCurrent_kpi-item__haxnl {
  background: transparent;
  padding: 18px 20px 16px;
  border-right: 1px solid var(--light-grey, #e8e8e8);
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
  border-left: 2px solid transparent;
  display: flex;
  flex-direction: column;
  min-height: 88px;
  transition: border-left-color 0.15s, background-color 0.15s;
}
.TabCurrent_kpi-item__haxnl:hover {
  background: #f9f9f9;
  border-left-color: var(--explore-color, #0f3460);
}
.TabCurrent_kpi-item__title__Z8YdW {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-2, #6b7280);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
}
.TabCurrent_kpi-item__value__HA9wM {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
  font-size: 24px;
  font-weight: 400;
  color: var(--explore-color, #0f3460);
  line-height: 1.15;
  letter-spacing: -0.02em;
  flex: 1 1;
}

.TabCurrent_signals__gUB\\+i {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
}
@media (max-width: 1200px) {
  .TabCurrent_signals__gUB\\+i {
    grid-template-columns: repeat(2, 1fr);
  }
}

.TabCurrent_signal-card__2bQFd {
  background: transparent;
  padding: 24px;
  border-right: 1px solid var(--light-grey, #e8e8e8);
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
}
.TabCurrent_signal-card--warning__swM34 {
  background: #fffef5;
}
.TabCurrent_signal-card__title__QYM9F {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-2, #6b7280);
  margin-bottom: 8px;
}
.TabCurrent_signal-card__text__EXW3H {
  font-size: 13px;
  color: var(--text-1, #1a1a2e);
  margin: 0;
  line-height: 1.55;
}
.TabCurrent_signal-card__text__EXW3H strong {
  color: var(--explore-color, #0f3460);
  font-weight: 600;
}

.TabCurrent_view-controls__sZw2T {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.TabCurrent_viewport__LjwPO {
  background: transparent;
  border: 1px solid var(--light-grey, #e8e8e8);
  min-height: 500px;
  display: flex;
  flex-direction: column;
}
.TabCurrent_viewport__map-placeholder__K317U {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background: transparent;
  color: var(--text-2, #6b7280);
  padding: 32px;
  min-height: 500px;
}

.TabCurrent_sparkline-wrapper__6FGOE {
  height: 24px;
  width: 80px;
}

.TabCurrent_drawer-header__69PGF {
  display: flex;
  align-items: center;
  gap: 16px;
}
.TabCurrent_drawer-header__avatar__t4qpo {
  width: 48px;
  height: 48px;
  background: #fafafa;
  border: 1px solid var(--light-grey, #e8e8e8);
  color: var(--explore-color, #0f3460);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.TabCurrent_drawer-header__info__Bu-Xb h2 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
}
.TabCurrent_drawer-header__info__Bu-Xb p {
  margin: 0;
  font-size: 13px;
  color: var(--text-2, #6b7280);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Collaborations/Tabs/Current/TabCurrent.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;EACA,oBAAA;AAAJ;AAEI;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAAN;;AAKA;EACE,aAAA;EACA,2DAAA;EACA,gDAAA;EACA,iDAAA;EACA,kBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,uBAAA;EACA,kDAAA;EACA,mDAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,2DAAA;AAFF;AAIE;EACE,mBAAA;EACA,gDAAA;AAFJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAHJ;AAME;EACE,+GAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;AAJJ;;AAQA;EACE,aAAA;EACA,qCAAA;EACA,gDAAA;EACA,iDAAA;AALF;AAOE;EANF;IAOI,qCAAA;EAJF;AACF;;AAOA;EACE,uBAAA;EACA,aAAA;EACA,kDAAA;EACA,mDAAA;AAJF;AAQE;EACE,mBAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;AAPJ;AAUE;EACE,eAAA;EACA,6BAAA;EACA,SAAA;EACA,iBAAA;AARJ;AAUI;EACE,oCAAA;EACA,gBAAA;AARN;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAVF;;AAaA;EACE,uBAAA;EACA,4CAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAVF;AAYE;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,uBAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;AAVJ;;AAeA;EACE,YAAA;EACA,WAAA;AAZF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAbJ;AAiBI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAfN;AAiBI;EACE,SAAA;EACA,eAAA;EACA,6BAAA;AAfN","sourcesContent":["// Doc-Ref: docs/features/collaborations-current.md\n.tab-current {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 8px 0 32px;\n\n  &__intro {\n    max-width: 800px;\n    margin-bottom: -16px;\n    \n    p {\n      color: var(--text-2, #6b7280);\n      font-size: 14px;\n      line-height: 1.6;\n      margin: 0;\n    }\n  }\n}\n\n.kpi-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  border-top: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 1px solid var(--light-grey, #e8e8e8);\n  margin-bottom: 8px;\n}\n\n.kpi-item {\n  background: transparent;\n  padding: 18px 20px 16px;\n  border-right: 1px solid var(--light-grey, #e8e8e8);\n  border-bottom: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 2px solid transparent;\n  display: flex;\n  flex-direction: column;\n  min-height: 88px;\n  transition: border-left-color 0.15s, background-color 0.15s;\n\n  &:hover {\n    background: #f9f9f9;\n    border-left-color: var(--explore-color, #0f3460);\n  }\n\n  &__title {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--text-2, #6b7280);\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    line-height: 1;\n  }\n\n  &__value {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-variant-numeric: tabular-nums;\n    font-size: 24px;\n    font-weight: 400;\n    color: var(--explore-color, #0f3460);\n    line-height: 1.15;\n    letter-spacing: -0.02em;\n    flex: 1;\n  }\n}\n\n.signals {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-top: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 1px solid var(--light-grey, #e8e8e8);\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.signal-card {\n  background: transparent;\n  padding: 24px;\n  border-right: 1px solid var(--light-grey, #e8e8e8);\n  border-bottom: 1px solid var(--light-grey, #e8e8e8);\n  // No side-stripe box-shadow — that's the 2018-SaaS-AI tell.\n  // Accent comes from the section header or semantic context, not a thick border.\n\n  &--warning {\n    background: #fffef5;\n  }\n\n  &__title {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--text-2, #6b7280);\n    margin-bottom: 8px;\n  }\n\n  &__text {\n    font-size: 13px;\n    color: var(--text-1, #1a1a2e);\n    margin: 0;\n    line-height: 1.55;\n\n    strong {\n      color: var(--explore-color, #0f3460);\n      font-weight: 600;\n    }\n  }\n}\n\n.view-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n\n.viewport {\n  background: transparent;\n  border: 1px solid var(--light-grey, #e8e8e8);\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n\n  &__map-placeholder {\n    flex: 1;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    background: transparent;\n    color: var(--text-2, #6b7280);\n    padding: 32px;\n    min-height: 500px;\n  }\n}\n\n// Sparkline inside table\n.sparkline-wrapper {\n  height: 24px;\n  width: 80px;\n}\n\n// Drawers\n.drawer-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n\n  &__avatar {\n    width: 48px;\n    height: 48px;\n    background: #fafafa;\n    border: 1px solid var(--light-grey, #e8e8e8);\n    color: var(--explore-color, #0f3460);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n  }\n\n  &__info {\n    h2 {\n      margin: 0 0 4px 0;\n      font-size: 18px;\n      font-weight: 500;\n      color: var(--text-1, #1a1a2e);\n    }\n    p {\n      margin: 0;\n      font-size: 13px;\n      color: var(--text-2, #6b7280);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-current": `TabCurrent_tab-current__dsDKC`,
	"tab-current__intro": `TabCurrent_tab-current__intro__FS9gQ`,
	"kpi-row": `TabCurrent_kpi-row__e6y9a`,
	"kpi-item": `TabCurrent_kpi-item__haxnl`,
	"kpi-item__title": `TabCurrent_kpi-item__title__Z8YdW`,
	"kpi-item__value": `TabCurrent_kpi-item__value__HA9wM`,
	"signals": `TabCurrent_signals__gUB+i`,
	"signal-card": `TabCurrent_signal-card__2bQFd`,
	"signal-card--warning": `TabCurrent_signal-card--warning__swM34`,
	"signal-card__title": `TabCurrent_signal-card__title__QYM9F`,
	"signal-card__text": `TabCurrent_signal-card__text__EXW3H`,
	"view-controls": `TabCurrent_view-controls__sZw2T`,
	"viewport": `TabCurrent_viewport__LjwPO`,
	"viewport__map-placeholder": `TabCurrent_viewport__map-placeholder__K317U`,
	"sparkline-wrapper": `TabCurrent_sparkline-wrapper__6FGOE`,
	"drawer-header": `TabCurrent_drawer-header__69PGF`,
	"drawer-header__avatar": `TabCurrent_drawer-header__avatar__t4qpo`,
	"drawer-header__info": `TabCurrent_drawer-header__info__Bu-Xb`
};
export default ___CSS_LOADER_EXPORT___;
